import React, { useEffect, useState } from "react";
import NavMenu from "./NavMenu";
import "./css/settings.css"
import AdminAboutme from "./settings/adminaboutme";
import AdminCV from "./settings/admincv";
import AdminLegal from "./settings/adminlegal";
import AdminProjects from "./settings/adminprojects";
import AdminEngagement from "./settings/adminengagement";
import AdminUsers from "./settings/adminusers";
import { API_BASE_URL, authHeaders } from "../api";

function Settings() {

    const [isAdmin, setIsAdmin] = useState(false);
    const [activePage, setActivePage] = useState("user");
    // "user" = Nutzerdaten
    // "admin" = Adminbereich

    async function deleteAccount(password, token) {


        try {
            const response = await fetch(`${API_BASE_URL}/api/deleteAccount`, {
                method: "DELETE",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": "Bearer " + token
                },
                body: JSON.stringify({
                    password: password
                })
            });

            const text = await response.text();

            let data = null;

            try {
                data = JSON.parse(text);
            } catch (err) {
                console.warn("Antwort ist kein JSON");
            }

            if (response.ok) {
                alert("Account gelöscht");

                localStorage.clear();
                window.location.href = "/";
            } else {
                alert(data?.error || "Fehler beim Löschen des Accounts");
            }

        } catch (err) {
            console.error("Request Fehler:", err);
            alert("Netzwerkfehler oder Server nicht erreichbar");
        }
    }
    const handleDeleteAccount = () => {
        const sessionData = localStorage.getItem("session");
        let session;
        session = JSON.parse(sessionData);
        deleteAccount(document.getElementById("password-for-delet").value, session.password);
    };


    useEffect(() => {
        let title = "Settings";

        if (activePage === "user") title = "User Settings";
        if (activePage === "admin") title = "Admin Settings";

        document.title = `${title} | James Schreiber Portfolio`;
    }, [activePage]);

    useEffect(() => {
        const checkLogin = async () => {
            const sessionData = localStorage.getItem("session");


            if (!sessionData) {
                window.location.href = "/";
                return;
            }

            let session;

            try {
                session = JSON.parse(sessionData);
            } catch (err) {
                localStorage.clear();
                window.location.href = "/";
                return;
            }

            if (!session.password) {
                localStorage.clear();
                window.location.href = "/";
                return;
            }

            try {
                const response = await fetch(`${API_BASE_URL}/api/auth`, {
                    method: "GET",
                    headers: authHeaders()
                });

                const data = await response.json();

                if (!data.valid) {
                    localStorage.clear();
                    window.location.href = "/";
                } else {
                    setIsAdmin(data.user.Admin);
                }

            } catch (err) {
                console.error(err);
            }
        };

        checkLogin();
    }, []);

    return (
        <>
            <NavMenu
                isadmin={isAdmin}
                setPage={setActivePage}
            />

            {activePage === "user" && (
                <div className="display-area">

                    <section className="datenschutz">
                        <h4>Datenspeicherung und -verarbeitung</h4>

                        <p>
                            Ich lege großen Wert auf den Schutz Ihrer personenbezogenen Daten. Daher speichere ich auf meinem Server ausschließlich die unbedingt erforderlichen Informationen. Diese sind:
                        </p>

                        <ul>
                            <li>Ihre Nutzer-ID</li>
                            <li>Ihr Nutzername</li>
                            <li>Ihr Passwort (verschlüsselt mittels Hashing und zusätzlicher Sicherheitsmaßnahmen wie „Salting“)</li>
                        </ul>

                        <p>
                            Eine darüber hinausgehende Speicherung personenbezogener Daten erfolgt nicht.
                        </p>

                        <p>
                            Auf Ihrem Endgerät (Client) werden ausschließlich technisch notwendige Daten im Local Storage gespeichert. Dies umfasst:
                        </p>

                        <ul>
                            <li>ein Authentifizierungs-Token</li>
                            <li>Ihren Nutzernamen</li>
                        </ul>

                        <p>
                            Diese Daten dienen ausschließlich der Bereitstellung der grundlegenden Funktionalität meiner Anwendung.
                        </p>

                        <h4>Löschung von Daten</h4>

                        <p>
                            Alle auf meinem Server gespeicherten Daten können jederzeit durch das Löschen Ihres Benutzerkontos vollständig entfernt werden.
                        </p>

                        <p>
                            Die auf Ihrem Endgerät gespeicherten Daten werden automatisch gelöscht, sobald Sie sich aus Ihrem Konto ausloggen oder den Local Storage Ihres Browsers manuell leeren.
                        </p>

                        <h4>Keine Weiterverarbeitung oder Weitergabe</h4>

                        <p>
                            Ich gebe keine Daten an Dritte weiter. Ebenso werden Ihre Daten nicht über den genannten Zweck hinaus verarbeitet.
                        </p>

                        <p>
                            Nach der Löschung Ihres Benutzerkontos werden sämtliche zugehörigen Daten dauerhaft und vollständig entfernt. Eine weitere Speicherung oder Verarbeitung findet nicht statt.
                        </p>
                    </section>

                    <div className="delet-accout-area">
                        <input type="password" className="password-input" placeholder="Passwort" id="password-for-delet" />
                        <button
                            type="button"
                            className="btn btn-danger"
                            onClick={handleDeleteAccount}
                        >
                            Account Löschen
                        </button>

                    </div>



                </div>

            )}

            {activePage === "admin" && isAdmin && (
                <div className="display-area">

                    <AdminAboutme />
                    <AdminCV />
                    <AdminProjects />
                    <AdminEngagement />
                    <AdminLegal />
                    <AdminUsers />


                </div>
            )}
        </>
    );
}

export default Settings;
